import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "featured col-span-12 flex flex-col h-96 overflow-y-auto gap-3 p-2 pb-0"
}
const _hoisted_2 = { class: "col-span-12" }
const _hoisted_3 = { class: "grid grid-cols-12 gap-2 p-2" }
const _hoisted_4 = { class: "col-span-8 grid gap-2" }
const _hoisted_5 = { class: "flex justify-center w-full" }
const _hoisted_6 = { class: "text-start" }
const _hoisted_7 = { class: "flex justify-center w-full" }
const _hoisted_8 = { class: "flex flex-col h-full bg-[#fbfaff] rounded-full col-span-5 gap-2" }
const _hoisted_9 = { class: "flex col-span-4 row-span-3 h-full border-2 border-[#aedddb] rounded-xl p-1 items-center justify-between" }
const _hoisted_10 = { class: "flex justify-center items-center w-full gap-2" }
const _hoisted_11 = {
  key: 1,
  class: "featured grid col-span-12 flex flex-col gap-2"
}
const _hoisted_12 = { class: "f-graph grid grid-cols-12 gap-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col col-span-2 pt-16 pr-12 font-semibold gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "shrink-0 grow-0 flex h-5 w-5 rounded-full border-2 border-black" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "invisible" }, "helolo")
    ]),
    /*#__PURE__*/_createElementVNode("p", { class: "uppercase text-lg leading-5 text-start ml-4" }, "Position of capability if aligned")
  ])
], -1)
const _hoisted_14 = { class: "flex flex-col gap-2 col-span-4 py-4 justify-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between border-2 border-[#aedddb] rounded-xl p-2 pl-3 w-full h-fit" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "leading-6" }, "Category"),
  /*#__PURE__*/_createElementVNode("div", { class: "flex border-2 border-[#aedddb] rounded-lg p-1 leading-4" }, "Mean")
], -1)
const _hoisted_16 = ["onMouseover"]
const _hoisted_17 = { class: "leading-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AgilityRatingPill = _resolveComponent("AgilityRatingPill")!
  const _component_GraphIci = _resolveComponent("GraphIci")!
  const _component_ItemBox = _resolveComponent("ItemBox")!

  return (_openBlock(), _createBlock(_component_ItemBox, {
    id: "item-n-4",
    visible: _ctx.visible,
    title: "Innovation Capability Index 2",
    headerItems: _ctx.headerItems,
    toggleClass: "item4-toggle minus",
    closeAction: _ctx.closeItem,
    graphViewClick: _ctx.graphViewClick,
    graphToggle: _ctx.graphToggle
  }, {
    default: _withCtx(() => [
      (_ctx.graphToggle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([
        {
          mean: _ctx.questionnaireResults.env_FACTORS,
          capabilities: [
            {
              capability: '1',
              mean: _ctx.questionnaireResults.slr_SENSING,
            },
            {
              capability: '2',
              mean: _ctx.questionnaireResults.srl_RESPONDING,
            },
            {
              capability: '3',
              mean: _ctx.questionnaireResults.srl_LEARNING,
            },
          ]
        }
      ], (factor, index) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(factor.capabilities, (capability) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: capability.capability,
                        class: "col-span-8 grid grid-cols-8 gap-2 pt-2 px-2"
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["flex col-span-2 rounded-xl p-1 items-center justify-between", _ctx.getBgClass(index)])
                        }, [
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("h4", _hoisted_6, _toDisplayString(capability.capability), 1)
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["flex col-span-1 rounded-xl py-1 px-4 items-center justify-between", _ctx.getBgClass(index)])
                        }, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("h4", null, _toDisplayString(capability.mean), 1)
                          ])
                        ], 2),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["resultProgressBar rounded-full h-full barTransition", _ctx.getColorClass(capability.mean, 'bg')]),
                            style: _normalizeStyle(_ctx.calculateBorder(capability.mean))
                          }, null, 6)
                        ])
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_AgilityRatingPill, {
                        score: factor.mean,
                        fill: true
                      }, null, 8, ["score"])
                    ])
                  ])
                ])
              ]))
            }), 256))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_GraphIci, {
                circles: _ctx.dynamicCircles,
                hoveredIndex: _ctx.hoveredIndex,
                setHoveredIndex: _ctx.setHoveredIndex,
                categories: _ctx.categories
              }, null, 8, ["circles", "hoveredIndex", "setHoveredIndex", "categories"]),
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: _normalizeClass(["flex justify-between rounded-xl p-2 pl-3 w-full h-fit duration-150 ease-in-out", _ctx.hoveredIndex === index ? 'bg-[#aedddb]' : 'bg-[#fbfaff]']),
                    onMouseover: ($event: any) => (_ctx.setHoveredIndex(index)),
                    onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setHoveredIndex(null)))
                  }, [
                    _createElementVNode("h4", _hoisted_17, _toDisplayString(category.name), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(["flex border-2 rating rounded-lg p-1 leading-4", [_ctx.getColorClass(category.mean, 'border'), { [_ctx.getColorClass(category.mean, 'bg')]: _ctx.hoveredIndex === index }]])
                    }, _toDisplayString(category.mean.toFixed(2)), 3)
                  ], 42, _hoisted_16))
                }), 128))
              ])
            ])
          ]))
    ]),
    _: 1
  }, 8, ["visible", "headerItems", "closeAction", "graphViewClick", "graphToggle"]))
}